import { useMutation } from '@tanstack/react-query';
import {
  WithdrawRequestService,
  RejectWithdrawRequestDto,
  RejectWithdrawRequestEntity,
} from 'services/openapi';

export type RejectRequestWithdrawType = {
  id: string;
  variables: RejectWithdrawRequestDto;
};
export const useRejectRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<RejectWithdrawRequestEntity, Error, RejectRequestWithdrawType>({
      mutationFn: (request: RejectRequestWithdrawType) => {
        return WithdrawRequestService.withdrawRequestControllerReject(
          request.id,
          request.variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
